/**
 * Which contact form was actually submitted. `form.posted_successfully?` is
 * true for every contact form on the page after any post, so this keeps only
 * the confirmation matching the redirect's fragment, which never reaches the
 * server. See AGENTS.md, "`form.posted_successfully?` belongs to the page".
 *
 * A file, not an inline script, because Cookiebot's auto-blocking silently
 * killed the inline version; data-cookieconsent="ignore" exempts it. Don't
 * inline it or spread that attribute -- see AGENTS.md, "Cookiebot's
 * auto-blocking can silently kill the theme's own inline scripts".
 *
 * ES5 and `var` to match the theme's other scripts.
 */
(function () {
  var successes = [].slice.call(document.querySelectorAll('[data-contact-success]'));
  if (!successes.length) {
    window.themePostedContactForm = null;
    return;
  }

  var posted = (window.location.hash || '').replace('#', '');

  // One confirmation on the page is unambiguous whatever the fragment says.
  if (successes.length === 1) {
    posted = successes[0].getAttribute('data-contact-success');
  }

  // No fragment and several confirmations: keep them all rather than show a
  // shopper who just submitted nothing. Defensive -- Shopify's redirect
  // always carries the fragment.
  if (!posted) {
    window.themePostedContactForm = null;
    return;
  }

  successes.forEach(function (el) {
    if (el.getAttribute('data-contact-success') === posted) return;
    // Removed, not hidden: a stray role="status" message is still announced.
    if (el.parentNode) el.parentNode.removeChild(el);
  });

  // Only the submitted form hides its fields, so the support widget stays
  // usable after a different form posts.
  var fields = document.querySelector('[data-contact-fields="' + posted + '"]');
  if (fields) fields.hidden = true;

  // Not `autofocus`, which fires before this runs and could land on a
  // message about to be removed.
  var survivor = document.querySelector('[data-contact-success="' + posted + '"]');
  if (survivor) {
    try { survivor.focus({ preventScroll: true }); } catch (e) {}
  }

  window.themePostedContactForm = posted;
})();
